import { render, staticRenderFns } from "./InventoryDetailsView.vue?vue&type=template&id=37cba711&scoped=true"
import script from "./InventoryDetailsView.vue?vue&type=script&lang=js"
export * from "./InventoryDetailsView.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetailsView.vue?vue&type=style&index=0&id=37cba711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cba711",
  null
  
)

export default component.exports